module.exports = __webpack_public_path__ + "img/vital.ff989519.png";